import { faEye, faPen, faPlus, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { BPIRevenueLessThan75lakhsDetailsForm } from ".";
import { IFormITR1, IProfessionalIncomes } from "../../../config/interfaces";
import { useAppSelector } from "../../../redux/Store";
import { ITRFilingSelector } from "../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import { ConfirmationModal } from "../../modals";

const BPIRevenueLessThan75lakhsDetails: React.FC = () => {
  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);
  const [showAddFormCanvas, setShowAddFormCanvas] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<IProfessionalIncomes | null>(null);

  const { values, setFieldValue, setValues } = useFormikContext<IFormITR1>();

  const ProfessionalIncomesDetails = values.IncomeDetails?.ProfessionalIncomes;

  const handleDeleteItem = async () => {
    setShowDeleteModal(() => null);
    handleTotalCalculation(null);
  };

  const handleTotalCalculation = (incomeData: IProfessionalIncomes | null) => {
    const PISection44ADA = Number(incomeData?.TotalSection44ADA || 0);

    const BPIncomes = {
      ...values.BusOrProfIncomes,
      PISection44ADA: PISection44ADA
    };

    const TotalBusOrProfIncome = Object.values(BPIncomes)?.reduce((acc, curr) => {
      return acc + curr;
    }, 0);

    const DATA = {
      BusOrProfIncomes: BPIncomes,
      TotalBusOrProfIncome: TotalBusOrProfIncome
    };

    setValues({ ...cloneDeep(values), ...DATA });
    setFieldValue("IncomeDetails.ProfessionalIncomes", incomeData);
  };

  return (
    <>
      <section className="mb-5">
        <div className="section-title-wrap">
          <h5>{`Professional Income (Revenue < 75 lakhs)  - Under section 44ADA`}</h5>
          <PreventEditComponent>
            {ProfessionalIncomesDetails ? (
              <Button
                variant="warning"
                size="sm"
                className="text-white"
                onClick={() => setShowAddFormCanvas(() => true)}
              >
                <FASvgIcon icon={faPen} />
                Edit
              </Button>
            ) : (
              <Button
                variant="secondary"
                size="sm"
                onClick={() => setShowAddFormCanvas(() => true)}
              >
                <FASvgIcon icon={faPlus} />
                Add
              </Button>
            )}
          </PreventEditComponent>

          {isFilingReadOnly && (
            <Button
              variant="warning"
              size="sm"
              className="text-white"
              onClick={() => setShowAddFormCanvas(() => true)}
            >
              <FASvgIcon icon={faEye} />
              View
            </Button>
          )}
        </div>

        {ProfessionalIncomesDetails ? (
          <dl className="eds-list eds-dl eds-inline-between">
            <RenderListItem
              title={"Professional Income (Revenue < 75 lakhs)"}
              sum={ProfessionalIncomesDetails.TotalSection44ADA}
              onClickDeleteBtn={() => {
                setShowDeleteModal(() => ProfessionalIncomesDetails);
              }}
            />
          </dl>
        ) : null}
      </section>

      <BPIRevenueLessThan75lakhsDetailsForm
        showCanvas={showAddFormCanvas}
        handleCloseBtnPress={(professionalIncomeData) => {
          if (professionalIncomeData) {
            handleTotalCalculation(professionalIncomeData);
          }
          setShowAddFormCanvas(() => false);
        }}
        formValues={ProfessionalIncomesDetails}
      />

      <ConfirmationModal
        showModal={!!showDeleteModal}
        iconColorClass="text-danger"
        title="Are you sure?"
        message={<p>{`You want to delete Professional Income (Revenue < 75 lakhs)`}</p>}
        onYesBtnClick={() => handleDeleteItem()}
        onNoBtnClick={() => setShowDeleteModal(() => null)}
        icon={faTrashAlt}
      />
    </>
  );
};

export default BPIRevenueLessThan75lakhsDetails;

const RenderListItem = ({
  title,
  sum = "0",
  onClickDeleteBtn
}: {
  title: string;
  sum: string;
  onClickDeleteBtn: () => void;
}) => {
  const shouldDisplay = sum !== "" && Number(sum) >= 0;

  return (
    <>
      {shouldDisplay && (
        <div className="eds-list--item">
          <dt>{title}</dt>
          <dd>
            <span>
              <PriceDisplay price={sum} />
            </span>
            <PreventEditComponent>
              <Button
                variant="transparent"
                className="icon-only"
                onClick={() => onClickDeleteBtn()}
              >
                <FASvgIcon icon={faTrash} />
              </Button>
            </PreventEditComponent>
          </dd>
        </div>
      )}
    </>
  );
};
